import {z} from 'zod';

import {parseJSON} from 'shared/web';

const HandoverDataSchema = z.object({
  scheduledDate: z.string().nullish(),
  completedDate: z.string().nullish(),
  mileage: z.string().nullish(),
  fuelAmount: z.string().nullish(),
});

export const getHandoverData = (dataJson: string) => {
  const data = parseJSON(dataJson, HandoverDataSchema);
  return data;
};
